import { lazy, type ReactNode } from 'react';
import i18n from '@/lib/i18n';
import type { ModuleManifest } from '@/lib/modules';
import { CanaryShell } from './components/CanaryShell';
import en from './i18n/en.json';
import es from './i18n/es.json';
import sr from './i18n/sr.json';

// The canary's strings live here and never in the shared locale files, which
// the children also edit.
for (const [lng, bundle] of Object.entries({ en, es, sr })) {
  i18n.addResourceBundle(lng, 'translation', bundle, true, true);
}

const CanaryHome = lazy(() => import('./pages/CanaryHome'));
const CanaryAdmin = lazy(() => import('./pages/admin/CanaryAdmin'));
const NotesList = lazy(() => import('./pages/notes/NotesList'));
const NoteEditor = lazy(() => import('./pages/notes/NoteEditor'));
const StressTest = lazy(() => import('./pages/stress/StressTest'));
const TasksList = lazy(() => import('./pages/tasks/TasksList'));

// The canary is an app of its own at /canary: no item in the app's sidebar,
// and every page sits in its own shell instead of the app layout
const page = (path: string, element: ReactNode) => ({ path, element: <CanaryShell>{element}</CanaryShell>, standalone: true });

const canary: ModuleManifest = {
  routes: [
    page('canary', <CanaryHome />),
    page('canary/notes', <NotesList />),
    page('canary/notes/:id', <NoteEditor />),
    page('canary/tasks', <TasksList />),
    page('canary/stress', <StressTest />),
    page('canary/admin', <CanaryAdmin />),
  ],
  navItems: [],
};

export default canary;
